import { c as _c } from "react/compiler-runtime";
import { Box, keyframes, Stack, SxProps, Theme } from '@mui/material';
interface DotsLoaderProps {
  color?: string;
  duration?: number;
  size?: number;
  sx?: SxProps<Theme>;
}
const bounce = keyframes`
    0%, 80%, 100% {
      transform: scale(0.7);
      opacity: 0.6;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  `;
export default function DotsLoader(props) {
  const $ = _c(25);
  const {
    duration: t0,
    color: t1,
    size: t2
  } = props;
  const duration = t0 === undefined ? 1.5 : t0;
  const color = t1 === undefined ? "primary.main" : t1;
  const size = t2 === undefined ? 8 : t2;
  let t3;
  if ($[0] !== color || $[1] !== size) {
    t3 = {
      width: size,
      height: size,
      bgcolor: color,
      borderRadius: 999
    };
    $[0] = color;
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const dotBase = t3;
  const t4 = `${bounce} ${duration}s infinite ease-in-out both`;
  let t5;
  if ($[3] !== t4) {
    t5 = {
      animation: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `-${duration * 0.32}s`;
  let t7;
  if ($[5] !== t6) {
    t7 = {
      animationDelay: t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `-${duration * 0.16}s`;
  let t9;
  if ($[7] !== t8) {
    t9 = {
      animationDelay: t8
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t5 || $[10] !== t7 || $[11] !== t9) {
    t10 = {
      display: "inline-flex",
      "& > div": t5,
      "& > div:nth-of-type(1)": t7,
      "& > div:nth-of-type(2)": t9
    };
    $[9] = t5;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  let t12;
  let t13;
  if ($[13] !== dotBase) {
    t11 = <Box sx={dotBase} />;
    t12 = <Box sx={dotBase} />;
    t13 = <Box sx={dotBase} />;
    $[13] = dotBase;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t13) {
    t14 = <Stack direction="row" spacing={0.5} sx={t10}>{t11}{t12}{t13}</Stack>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== props.sx || $[23] !== t14) {
    t15 = <Box sx={props.sx}>{t14}</Box>;
    $[22] = props.sx;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
}